// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper/bundle';
window.Swiper = Swiper;
